import type { ConceptDef } from '../types';

export const matchPictureToWord: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-picture-to-word',
  label: 'Match Picture-to-Word',
  category: 'Matching',
  description: 'See a picture; tap the matching word.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: '🍎', answer: 'apple' },
      { say: '🐶', answer: 'dog' },
      { say: '🚗', answer: 'car' },
      { say: '🌳', answer: 'tree' },
      { say: '⚽', answer: 'ball' },
      { say: '⭐', answer: 'star' },
    ],
  },
};
